export const namespaced = true
const getDefaultState = () => {
    return {
        catalog: null,
         child: null,    
    }
}
export const state = getDefaultState()

export const mutations = {
    SET_CATALOG(state, catalog) {
        state.catalog = catalog
    },
    SET_CHILD(state, child) {
    state.child = child
  },
    RESET_STATE(state) {
        Object.assign(state, getDefaultState())
    },
}

export const actions = {
  setCatalog({commit}, catalog) {
    commit('SET_CATALOG', catalog);
  },
  setChild({ commit }, child) {
    commit("SET_CHILD", child);
  },
    resetState({commit}) {
        commit('RESET_STATE');
    },
};

export const getters = {
    getCatalog: (state) => state?.catalog,
    getChild: (state) => state?.child, 
}
